export const RELOAD = "RELOAD";
export const REDIRECT = "REDIRECT";
export const TAB = "TAB";
export const STACK_NOTIFICATION = "STACK_NOTIFICATION";
export const SWEET_ALERT_NOTIFICATION = "SWEET_ALERT_NOTIFICATION";
export const INFO = "INFO";
